import { render, staticRenderFns } from "./IsOk.vue?vue&type=template&id=36c01034&scoped=true"
import script from "./IsOk.vue?vue&type=script&lang=js"
export * from "./IsOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c01034",
  null
  
)

export default component.exports